export enum TransferOfferStatusEnum {
  OPENED = 'opened',
  CLOSED = 'closed',
  FAILED = 'failed',
}
